export default {
  name: "AppDetailTab3-third"
};